import type { PresentationModule } from '../../../presentation/types';
import { mintIt } from './content';
import { MintItScene } from './scenes/MintItScene';

export const mintItModule: PresentationModule = {
  id: 'mint-it',
  label: 'MINT-IT',
  priority: 'flagship',
  parent: 'mint',
  scenes: [
    { ...mintIt, module: 'mint-it', create: (resolved) => new MintItScene(resolved) },
  ],
};
